module.exports = __webpack_public_path__ + "static/media/feature_icon_4.44e430ac.png";